// Polygon (POS) supported assets — the ONLY network allowed for buy/send/receive/swap.
// POL is the native gas token.

export const SUPPORTED_SYMBOLS = new Set<string>([
  'POL',
  'WETH',
  'WBTC',
  'USDT',
  'USDC',
  'DAI',
  'STMATIC',
  'WSTETH',
  'AAVE',
  'LINK',
  'UNI',
  'CRV',
  'SUSHI',
  'MKR',
  'COMP',
  'BAL',
  'SNX',
  'GRT',
  '1INCH',
  'LDO',
]);

export function isSupportedCrypto(symbol: string): boolean {
  return SUPPORTED_SYMBOLS.has(symbol.toUpperCase());
}
